import cn from "clsx";
import { memo } from "react";

type PaperElementProps = {
  className?: string;
  isLandscape?: boolean;
  isSquare?: boolean;
  active?: boolean;
};

function PaperElement({
  active = false,
  isLandscape = false,
  className = "",
  isSquare,
}: PaperElementProps) {
  return (
    <div className={cn("relative overflow-hidden", className)}>
      <span
        className={cn("block border", {
          "w-[56px] h-[80px]": !isSquare,
          "w-[80px] h-[80px]": isSquare,
          "w-[80px] max-h-[56px]": isLandscape,
          "bg-white border-grey-60": !active,
          "bg-grey-20 border-grey-80": active,
        })}
      />
      <span
        className={cn("absolute -right-px -top-px block size-[10px] origin-top-left border", {
          "bg-white border-grey-60": !active,
          "bg-grey-20 border-grey-80": active,
        })}
      />
      <span
        className={cn(
          "absolute right-0 top-0 z-10 block h-[15px] w-[10px] origin-top-left -rotate-45 border bg-white",
          {
            "border-grey-60": !active,
            "border-grey-80": active,
          },
        )}
      />
    </div>
  );
}

export default memo(PaperElement);
